module.exports = __webpack_public_path__ + "static/media/walk-the-talk.61aa09dc.PNG";